import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "flex items-center justify-between gap-3" }
const _hoisted_3 = { class: "text-sm font-semibold text-black" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = { class: "block text-sm font-medium text-black" }
const _hoisted_6 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_7 = { class: "block text-sm font-medium text-black" }
const _hoisted_8 = ["onUpdate:modelValue", "disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-xs text-blue-700"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-1 text-xs text-amber-700"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "rounded-lg border border-gray-200 p-4" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2 text-xs text-amber-700"
}
const _hoisted_15 = {
  key: 0,
  class: "text-sm font-medium text-red-600"
}
const _hoisted_16 = { class: "flex justify-end gap-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}

import { ref, watch } from "vue";
import ModalComp from "@/components/ui/ModalComp.vue";
import UploadZone from "@/components/order/UploadZone.vue";
import type { FreeShippingTrackingParcelInput } from "@/api/orders";
import {
  detectFreeShippingCarrier,
  FREE_SHIPPING_CARRIERS,
  normalizeTrackingNumber,
} from "@/utils/freeShippingTracking";

interface ParcelDraft {
  key: number;
  trackingNumber: string;
  carrierId: number | null;
  detectedCarrierId: number | null;
}

const maxParcels = 30;

export default /*@__PURE__*/_defineComponent({
  __name: 'FreeShippingConfirmationModal',
  props: {
    isVisible: { type: Boolean },
    orderId: {},
    orderGroupId: {},
    orderDate: {},
    invoiceId: {},
    loading: { type: Boolean }
  },
  emits: ["update:isVisible", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const carriers = FREE_SHIPPING_CARRIERS;
let nextParcelKey = 1;

const createParcel = (): ParcelDraft => ({
  key: nextParcelKey++,
  trackingNumber: "",
  carrierId: null,
  detectedCarrierId: null,
});

const parcels = ref<ParcelDraft[]>([createParcel()]);
const invoiceCount = ref(0);
const validationError = ref("");

const detectedCarrierLabel = (parcel: ParcelDraft) => {
  if (!parcel.detectedCarrierId) return "";
  return (
    carriers.find((carrier) => carrier.id === parcel.detectedCarrierId)?.label ||
    ""
  );
};

const onTrackingInput = (parcel: ParcelDraft) => {
  validationError.value = "";
  const detected = detectFreeShippingCarrier(parcel.trackingNumber);
  if (
    parcel.carrierId == null ||
    parcel.carrierId === parcel.detectedCarrierId
  ) {
    parcel.carrierId = detected;
  }
  parcel.detectedCarrierId = detected;
};

const addParcel = () => {
  if (parcels.value.length >= maxParcels) return;
  parcels.value.push(createParcel());
};

const removeParcel = (index: number) => {
  if (parcels.value.length === 1) return;
  parcels.value.splice(index, 1);
};

watch(
  () => props.isVisible,
  (visible) => {
    validationError.value = "";
    if (!visible) return;
    nextParcelKey = 1;
    parcels.value = [createParcel()];
  },
);

const confirm = () => {
  const normalized: FreeShippingTrackingParcelInput[] = [];
  const seen = new Set<string>();

  for (const [index, parcel] of parcels.value.entries()) {
    let trackingNumber = normalizeTrackingNumber(parcel.trackingNumber);
    if (trackingNumber.length < 5) {
      validationError.value = `Renseignez un numéro de suivi valide pour le colis ${index + 1}.`;
      return;
    }
    if (!parcel.carrierId) {
      validationError.value = `Sélectionnez le transporteur du colis ${index + 1}.`;
      return;
    }
    if (parcel.carrierId === 10 && trackingNumber.startsWith("092")) {
      trackingNumber = trackingNumber.slice(3);
    }
    if (seen.has(trackingNumber)) {
      validationError.value = "Chaque colis doit avoir un numéro de suivi différent.";
      return;
    }
    seen.add(trackingNumber);
    normalized.push({
      trackingNumber,
      carrierId: parcel.carrierId,
    });
  }

  emit("confirm", {
    trackingNumber: normalized[0].trackingNumber,
    carrierId: normalized[0].carrierId,
    parcels: normalized,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComp, {
    "is-visible": _ctx.isVisible,
    title: "Confirmer la livraison gratuite",
    size: "lg",
    "hide-footer": true,
    "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "rounded-lg border border-emerald-200 bg-emerald-50 p-4" }, [
          _createElementVNode("p", { class: "font-semibold text-emerald-900" }, "Livraison offerte par le vendeur"),
          _createElementVNode("p", { class: "mt-1 text-sm text-emerald-800" }, " Aucun identifiant de livraison eFashion n'est nécessaire. Ajoutez un numéro de suivi par colis : ils seront transmis au client. ")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parcels.value, (parcel, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: parcel.key,
            class: "space-y-3 rounded-lg border border-gray-200 p-4"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, "Colis " + _toDisplayString(index + 1), 1),
              (parcels.value.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "text-sm text-red-600 hover:underline disabled:cursor-not-allowed disabled:text-gray-400",
                    disabled: _ctx.loading,
                    onClick: ($event: any) => (removeParcel(index))
                  }, " Retirer ", 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_5, [
              _cache[3] || (_cache[3] = _createTextVNode(" Numéro de suivi ")),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-red-600" }, "*", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((parcel.trackingNumber) = $event),
                type: "text",
                autocomplete: "off",
                class: "mt-1 w-full rounded-md border border-gray-300 px-3 py-2 uppercase",
                placeholder: "Ex. 1Z999AA10123456784",
                disabled: _ctx.loading,
                onInput: ($event: any) => (onTrackingInput(parcel))
              }, null, 40, _hoisted_6), [
                [_vModelText, parcel.trackingNumber]
              ])
            ]),
            _createElementVNode("label", _hoisted_7, [
              _cache[6] || (_cache[6] = _createTextVNode(" Transporteur ")),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-red-600" }, "*", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((parcel.carrierId) = $event),
                class: "mt-1 w-full rounded-md border border-gray-300 bg-white px-3 py-2",
                disabled: _ctx.loading
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("option", {
                  value: null,
                  disabled: ""
                }, "Sélectionner un transporteur", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carriers), (carrier) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: carrier.id,
                    value: carrier.id
                  }, _toDisplayString(carrier.label), 9, _hoisted_9))
                }), 128))
              ], 8, _hoisted_8), [
                [
                  _vModelSelect,
                  parcel.carrierId,
                  void 0,
                  { number: true }
                ]
              ]),
              (detectedCarrierLabel(parcel))
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Transporteur détecté : " + _toDisplayString(detectedCarrierLabel(parcel)) + ". Vous pouvez le modifier si nécessaire. ", 1))
                : (parcel.trackingNumber)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Détection incertaine : choisissez le transporteur correspondant. "))
                  : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("button", {
          type: "button",
          class: "text-sm font-medium text-blue-700 hover:underline disabled:cursor-not-allowed disabled:text-gray-400",
          disabled: _ctx.loading || parcels.value.length >= maxParcels,
          onClick: addParcel
        }, " Ajouter un numéro de suivi ", 8, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-semibold text-black" }, "Facture recommandée", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-600" }, " Ajoutez-la si elle est disponible. Son absence n'empêche pas la confirmation. ", -1)),
          _createVNode(UploadZone, {
            "order-id": _ctx.orderId,
            "order-group-id": _ctx.orderGroupId,
            "order-date": _ctx.orderDate,
            "invoice-id": _ctx.invoiceId,
            onInvoicesCountChanged: _cache[0] || (_cache[0] = ($event: any) => (invoiceCount.value = $event))
          }, null, 8, ["order-id", "order-group-id", "order-date", "invoice-id"]),
          (invoiceCount.value === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Aucune facture jointe : vous pouvez continuer et l'ajouter plus tard. "))
            : _createCommentVNode("", true)
        ]),
        (validationError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(validationError.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50",
            disabled: _ctx.loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:isVisible', false)))
          }, " Annuler ", 8, _hoisted_17),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-400",
            disabled: _ctx.loading,
            onClick: confirm
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_19))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.loading ? "Confirmation..." : "Confirmer la commande"), 1)
          ], 8, _hoisted_18)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})